import { Component, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Observable, map, startWith, tap } from 'rxjs';
import { IHttpResponse } from '@libs/interfaces';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SignService } from '@libs/app.services/sign/sign.service';
import { EmailInputComponent } from '../email-input/email-input';
import { PhoneInputComponent } from '../phone-input/phone-input';
import { SubmitSpinnerComponent } from '@libs/stand-alone-components/commons/submit-spinner/submit-spinner';
import { LocalstorageService } from '@libs/app.services/landing/localstorage.service';
@Component({
  selector: 'app-sign-in',
  templateUrl: './signIn.component.html',
  styleUrls: ['./signIn.component.scss'],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    EmailInputComponent,
    PhoneInputComponent,
    SubmitSpinnerComponent,
  ],
})
export class SignInComponent implements OnInit {
  method = signal<'email' | 'celular'>('email');
  loading = signal(false);
  errorMassage = signal('');
  dataForm = signal<FormGroup>(null);
  showWarning$: Observable<string>;
  valid$: Observable<boolean>;
  constructor(
    private formBuilder: FormBuilder,
    private ls: LocalstorageService,
    private router: Router,
    private sign: SignService,
  ) {}
  ngOnInit(): void {
    this.setupdataForm();
    this.valid$ = this.dataForm().valueChanges.pipe(
      startWith(true),
      map(() => {
        return this.isEmail ? this.dataForm().controls['email'].valid : this.dataForm().controls['phone'].valid;
      }),
    );
  }
  private setupdataForm() {
    this.ls.phone && this.method.set('celular');
    this.dataForm.set(
      this.formBuilder.group({
        email: [this.ls.email || '', Validators.compose([Validators.required, Validators.email])],
        phone: [
          this.ls.phone || '',
          Validators.compose([Validators.required, Validators.minLength(11), Validators.maxLength(11)]),
        ],
      }),
    );
  }
  submit() {
    if (this.valid && !this.loading()) {
      this.loading.set(true);
      this.showWarning$ = null;
      const value = this.isEmail ? this.dataForm().value.email.toLowerCase() : this.dataForm().value.phone;
      this.showWarning$ = this.sign.generateCode(value).pipe(
        tap(() => this.loading.set(false)),
        map((response: IHttpResponse) => this.checkResponse(value, response)),
        tap((errorMassage: string) => this.errorMassage.set(errorMassage)),
      );
    }
  }
  private checkResponse(value: string, response: IHttpResponse) {
    const valid: boolean = response?.data;
    if (valid) {
      this.localstoreValue(value);
      this.router.navigate(['/sign/code'], { queryParams: { value: value } });
      return '';
    } else {
      return 'ERRORS.USER_EMAIL_REGISTERED';
    }
  }
  toggle() {
    this.method.update(val => (val == 'email' ? 'celular' : 'email'));
  }
  private localstoreValue(value: string) {
    this.isEmail ? this.ls.storeEmail(value) : this.ls.storePhone(value);
  }
  private get valid() {
    return this.isEmail ? this.dataForm().controls['email'].valid : this.dataForm().controls['phone'].valid;
  }
  private get isEmail() {
    return this.method() == 'email';
  }
  private get isCelular() {
    return this.method() == 'celular';
  }
}
